<template>
  <homepage
    :page_slug="`homepage__${slider_variant}`"
    :slider_variant="slider_variant"
    :default_blocks="default_blocks"
    :site_blocks="site_blocks"
  />
</template>

<script>
import { mapState, mapGetters } from "vuex"
import Homepage from '@/components/views/homepage.vue'
import Suggestions from '@alpitour/components/blocks/suggestions.vue'
import Brands from '@alpitour/components/blocks/brands.vue'
import StaticBlocks from '@alpitour/components/blocks/static-blocks.vue'
import FlyBy from '@alpitour/components/blocks/fly-by.vue'
import { get_config, is_authenticated } from "@src/utilities"
import { PACKAGE_TYPES, PACKAGE_TYPE_PROVIDER } from "@alpitour/resources"
import { get_configured_package_type } from '@alpitour/components/blocks/booking-engine/logic/package-type-tabs'
import { STATIC_BLOCKS } from "./logic"

const SITE_BLOCKS = {
  brands: { component: Brands, wrap: 'container' },
  'static-blocks': { component: StaticBlocks, wrap: 'container' },
  suggestions: { component: Suggestions, wrap: 'container' },
  'fly-by': { component: FlyBy, wrap: 'container' },
}

export default {
  name: 'homepage-view',
  components: {
    'homepage': Homepage,
  },
  data() {
    return {
      site_blocks: SITE_BLOCKS,
      suggestions: get_config('searchSuggestions', []),
      suggestions_autoplay_speed: get_config('guiSettings.autoplaySpeedSuggestions', 0),
    }
  },
  computed: {
    ...mapGetters(
      "liveat", ["is_flight_and_stay_package"]
    ),
    // module state keys
    ...mapState("liveat", [
      'package_type',
    ]),
    slider_variant() {
      let { package_type } = this
      if (!PACKAGE_TYPE_PROVIDER[package_type]) {
        package_type = get_configured_package_type() || PACKAGE_TYPES.FLIGHT_AND_STAY
      }
      return PACKAGE_TYPE_PROVIDER[package_type]
    },
    // contenuti statici della home, usati come pagina di default senza CMS
    default_blocks() {
      const blocks = [
        { component: 'brands' },
        { component: 'static-blocks', props: { blocks: STATIC_BLOCKS[this.package_type] } },
      ]
      if (this.suggestions.length && this.is_flight_and_stay_package) {
        blocks.push({
          component: 'suggestions',
          props: { suggestions: this.suggestions, autoplay: this.suggestions_autoplay_speed },
        })
      }
      blocks.push(
        { component: 'fly-by' },
        {
          component: 'point-list',
          props: {
            pl: [
              {
                pl_icon: 'shield',
                pl_title: 'I migliori brand italiani',
                pl_text:
                  'Alpitour, Francorosso, Bravo, Edenviaggi e tanti altri. Il meglio delle vacanze in tutto il mondo.',
              },
              {
                pl_icon: 'happy_pin',
                pl_title: 'Per il welfare aziendale',
                pl_text:
                  'Un servizio pensato per un\'utenza aziendale, dal booking online all\'assistenza',
              },
              {
                pl_icon: 'hands',
                pl_title: 'Conferma immediata',
                pl_text:
                  'Nessuna burocrazia, nessun rimborso e nessun voucher. Prenoti con un click!',
              },
              {
                pl_icon: 'heart',
                pl_title: 'Come in agenzia ma online',
                pl_text: `Solo su ${get_config('site.brand', '')} ${get_config('site.payoff', '')} trovi un'assistenza attenta e dedicata anche su webchat e WhatsApp`,
              },
            ],
          },
        },
      )
      // welfare non sufficiente
      if (is_authenticated() && get_config('integration.welfare')) {
        blocks.push({
          component: 'image-with-text-cta',
          props: {
            image_src: 'assets/images/alpitour/statics/iStock-1180231917.png',
            text_heading: 'Welfare non sufficiente?',
            text_content: 'Se il tuo credito welfare non è sufficiente troviamo insieme una soluzione.',
            text_cta: [
              {
                cta_text: `Contattaci`,
                cta_icon: 'phone',
                cta_url: `tel:${get_config('site.phoneNumber', '')}`,
              },
            ],
          },
        })
      }
      blocks.push({
        component: 'value-proposition',
        props: {
          vp: [
            {
              vp_image: 'assets/images/alpitour/statics/iStock-1208856002.jpg',
              vp_content: [
                {
                  vp_icon: 'symbol_vv',
                  vp_title: 'Hai bisogno di un consiglio?',
                  vp_text:
                    `Se cerchi un suggerimento o la soluzione a tue specifiche esigenze, parla con un nostro consulente. <strong><a href="tel:${
                    get_config('site.phoneNumber', '')
                    }">Chiamaci allo ${ 
                    get_config('site.phoneNumber', '') 
                    }</a></strong>`,
                },
                {
                  vp_icon: 'symbol_vv',
                  vp_title: 'Su di noi puoi contare!',
                  vp_text:
                    'Solo Vacanze VadoBay ti offre un\'assistenza multicanale, telefonica, webchat, WhatsApp, email, webcall a portata di click e dedicata a gli utenti di welfare aziendale. ',
                  vp_support_action: 'Parla con noi!',
                  vp_cta_id: 'alpitour-homepage-vp-multichannel',
                },
              ],
            },
          ],
        },
      })
      return blocks
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .section.section--booking-engine {
      z-index: 100;

      @include media-breakpoint-up(md) {
        margin-top: $grid-gutter-width * 2;
      }

      .booking-engine {
        @include media-breakpoint-up(md) {
          margin-top: -140px;
        }
      }
    }

    .image-with-text-cta {
      background: $white;

      &__image img {
        object-position: center 20%;
        width: 1600px;
        right: 0;
        left: 0;
        margin: 0 auto;
      }
    }

    .hero--slider-item {
      &:after {
        background-color: $primary;
      }
      .vb-heading,
      .text {
        @include media-breakpoint-up(md) {
          color: $white !important;
        }
      }
      .captions {
        .vb-icon {
          display: none;
        }
      }
    }
  }
</style>
